import withStyles from '@material-ui/core/styles/withStyles';
import CarIcon from '@serko/zui-icons/es/CarIcon';
import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { CarSegmentDetails } from '../../../../../../../../models/itinerary';
import { Logo } from './Logo';

interface OwnProps {
  /**
   * Supplier code
   *
   * @example
   * "ZE" // Hertz Corporation logo
   */
  code: CarSegmentDetails['supplierCode'];

  /**
   * Supplier name
   *
   * @example
   * "Virgin Airways"
   */
  name: CarSegmentDetails['supplierName'];
}

interface CarLogoProps extends OwnProps {}

class CarLogoBase extends PureComponent<CarLogoProps> {
  private get src() {
    return `./rentalcar-logos/${this.props.code}_1x.png`;
  }
  public render() {
    const { name, code, ...props } = this.props;
    return <Logo src={this.src} alt={name} fallbackIcon={CarIcon} {...props} />;
  }
}

const enhance = compose<CarLogoProps, OwnProps>(
  withStyles({}, { name: 'ZuiImage' }), // Logos component is expecting the element.type.options.name to be 'ZuiImage'
);

export const CarLogo = enhance(CarLogoBase);

CarLogo.displayName = 'CarLogo';
